module.exports = __webpack_public_path__ + "img/rtvda.71d1b110.svg";